import styled from 'styled-components'

import { Tag } from '@presentation/components/atoms'

export const Container = styled(Tag)`
  font-size: 0.8rem;
  padding: 0.5rem;
`
